<template>
  <form @submit.prevent="save">
    <div ref="notes">
      <mia-car-edit-feature-textarea
        v-model="form.notes"
        label="Anmerkungen"
        :errors="getErrors('item_notes')"
        rows="4"
        @input="clearErrors('item_notes')"
      >
        <template #label="{ label, htmlFor }">
          <div class="flex items-start justify-between">
            <label
              :for="htmlFor"
              class="mb-2 mr-2 tracking-wider text-gray-800"
              v-text="label"
            />

            <button
              type="button"
              class="text-gray-900 transition-colors duration-150 hover:text-orange-mia ease-out-fast focus:outline-none"
              @click="addNote('notes')"
            >
              &raquo; Anmerkung hinzufügen
            </button>
          </div>
        </template>
      </mia-car-edit-feature-textarea>
    </div>
    <div
      ref="notesShared"
      class="mt-6"
    >
      <mia-car-edit-feature-textarea
        v-model="form.notesShared"
        label="Freigegebene Anmerkungen für angeschlossene Händler"
        :errors="getErrors('item_notes_shared')"
        rows="4"
        @input="clearErrors('item_notes_shared')"
      >
        <template #label="{ label, htmlFor }">
          <div class="flex items-start justify-between">
            <label
              :for="htmlFor"
              class="mb-2 mr-2 tracking-wider text-gray-800"
              v-text="label"
            />

            <button
              type="button"
              class="text-gray-900 transition-colors duration-150 hover:text-orange-mia ease-out-fast focus:outline-none"
              @click="addNote('notesShared')"
            >
              &raquo; Anmerkung hinzufügen
            </button>
          </div>
        </template>
      </mia-car-edit-feature-textarea>
    </div>
    <div class="flex justify-end mt-4">
      <mia-submit-button
        label="Speichern"
        :disabled="$wait.any"
        :is-loading="$wait.is('updating notes')"
      />
    </div>
  </form>
</template>

<script>
import { DateTime } from 'luxon'
import { getCar } from '@/api/car'
import { updateNotes } from '@/api/cars'
import FeatureTextarea from '@/components/cars/edit/FeatureTextarea.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'Notices',

  components: {
    'mia-car-edit-feature-textarea': FeatureTextarea,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data: () => ({
    form: {
      notes: '',
      notesShared: ''
    }
  }),

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  },

  watch: {
    car: {
      immediate: true,
      deep: true,
      handler(car) {
        this.form.notes = car.item_notes
        this.form.notesShared = car.item_notes_shared
      }
    }
  },

  methods: {
    async save() {
      this.$wait.start('updating notes')

      const [errors] = await updateNotes(this.car.id, {
        item_notes: this.form.notes,
        item_notes_shared: this.form.notesShared
      })

      this.$wait.end('updating notes')

      if (errors) {
        this.handleBackendValidationErrors(errors)
        window.eventBus.$emit('mia-error', {
          error: ['Die Anmerkungen konnten nicht aktualisiert werden.']
        })
        return
      }

      this.resetErrors()
      this.car = await getCar({
        carId: this.car.id
      })

      window.eventBus.$emit('mia-info', {
        info: ['Anmerkungen wurden erfolgreich aktualisiert.']
      })
    },

    addNote(field) {
      const textarea = this.$refs[field].querySelector('textarea')
      const isEmpty = this.form[field].trim().length === 0
      const now = DateTime.local()
      const prepend = `${this.authUser.item_firstname} ${this.authUser.item_lastname} am ${now.toFormat('dd.MM.yyyy')}: `

      this.$set(this.form, field, `${this.form[field]}${isEmpty ? '' : '\n\n'}${prepend}`)
      textarea.focus()
    }
  }
}
</script>
